<script>
  import {
    replacementRate,
    estimatedPension,
    inflationAdjustedPension,
    reportCopy,
    getCopyId,
  } from "../../stores/currentSelections.js";
  import Tooltip from "./Tooltip.svelte";

  import formatPercent from "../../utils/formatPercent.js";
  import formatDollars from "../../utils/formatDollars.js";

  export let output;

  let copyKey = getCopyKey();
  let title = getCopyId($reportCopy, `calculator-outputs-${copyKey}`);
  let tooltip = getCopyId($reportCopy, `calculator-outputs-${copyKey}-tooltip`);

  function getCopyKey() {
    if (output === "benefitValue") return "benefit";
    if (output === "estimatedPension") return "estimated";
    if (output === "inflationAdjustedPension") return "inflation";
  }
</script>

<div class="relative px-6 pt-4 bg-blue-lightest output-container">
  <p class="font-bold text-neutral-1 tight">{title}</p>
  {#if output === "benefitValue"}
    <div class="absolute flex flex-row items-center output-value">
      <p class="font-bold big-number text-blue-dark sm:mb-2 md:mb-0">
        {formatPercent($replacementRate) || "--%"}
      </p>
      <div class="ml-1">
        <Tooltip
          content={tooltip}
          yTranslate="0.25"
          yTranslateDir=""
          color="#082A30"
        />
      </div>
    </div>
  {:else if output === "estimatedPension"}
    <div class="absolute flex flex-row items-center output-value">
      <p class="mb-2 font-bold big-number text-blue-dark md:mb-0">
        {formatDollars($estimatedPension) || "$--"}
      </p>
      <div class="ml-1">
        <Tooltip
          content={tooltip}
          yTranslate="0.25"
          yTranslateDir=""
          color="#082A30"
        />
      </div>
    </div>
  {:else if output === "inflationAdjustedPension"}
    <div class="absolute flex flex-row items-center output-value">
      <p class="mb-2 font-bold big-number text-blue-dark md:mb-0">
        {formatDollars($inflationAdjustedPension) || "$--"}
      </p>
      <div class="ml-1">
        <Tooltip
          content={tooltip}
          yTranslate="0.25"
          yTranslateDir=""
          color="#082A30"
        />
      </div>
    </div>
  {/if}
</div>

<style>
  .output-container {
    padding-bottom: 80px;
  }

  .output-value {
    top: 100%;
    bottom: 0px;
    transform: translateY(-100%);
    height: 80px;
  }
</style>
